export enum ShipmentMailStatus {
    SENT = 'SENT',
    NOT_SENT = 'NOT_SENT',
    FAILED = 'FAILED',
}
